module.exports = __webpack_public_path__ + "img/banner.492ab89a.png";